module.exports = __webpack_public_path__ + "static/img/gsysbg-D99bLSNL.2744e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/gsysbg-D99bLSNL.png
// module id = Jepx
// module chunks = 16